package one.healthium.login.ui.magic_link

import androidx.compose.runtime.Immutable

@Immutable
data class MagicLinkUiState(
    val loading: Boolean = false,
    val magicLinkUiOptions: MagicLinkUiOptions = MagicLinkUiOptions(),
)
